import { useEffect, useState } from 'react';

import { getAllSpeciesAtLocation } from '../../../api/fishrules/getAllSpeciesAtLocation';
import { ICoordinates } from '../../../interfaces/geo';
import { reportMykissClientError } from '../../errorHandling/client';
import { formatAllSpeciesData, FormattedSpecies } from '../../regulations/formatAllSpeciesData';

interface Result {
  isLoading: boolean;
  allSpecies: FormattedSpecies[];
}

export function useAllSpeciesAtLocation(params: ICoordinates | void): Result {
  const latitude = params?.latitude;
  const longitude = params?.longitude;
  const [isLoading, setIsLoading] = useState(true);
  const [allSpecies, setAllSpecies] = useState<FormattedSpecies[]>([]);

  useEffect(() => {
    if (!latitude || !longitude) {
      return;
    }
    const controller = new AbortController();
    setIsLoading(true);

    getAllSpeciesAtLocation({ latitude, longitude }, controller.signal)
      .then(results => {
        setAllSpecies(formatAllSpeciesData(results));
        setIsLoading(false);
      })
      .catch(error => {
        if (error.name !== 'AbortError') {
          reportMykissClientError(error);
        }
        setIsLoading(false);
      });

    return () => {
      controller.abort();
    };
  }, [latitude, longitude]);

  return { isLoading, allSpecies };
}
